import { getSubstrateResourceName } from './getSubstrateResourceName';

export const getSubstrateSearchUrl =
  (version: string = 'v1') =>
  (path: string, queryString?: string) => {
    const substrateRootPath = getSubstrateResourceName();
    const substrateSearchUrl = `search/api/${version}${path}`;
    const url: URL = new URL(substrateSearchUrl + (queryString ? `&${queryString}` : ''), substrateRootPath);
    return url;
  };
